import Cookies from '@components/cookies'
import parseJSON from '@utilities/parse-json'
import addAlertMessage from '@utilities/errors/add-alert-message'
import removeAlertMessage from '@utilities/errors/remove-alert-message'
import Events from '@utilities/events'
import GoogleMaps from '@utilities/google-maps'

import Component from '@utilities/store/lib/component'
import store from '@utilities/store'

const HAS_SEARCHED_CLASS = 'store-locator--known-location'
const JS_HOOK_MAP = '[js-hook-store-locator]'
const JS_HOOK_ALERT = '[js-hook-store-locator-alert]'

class StoreLocator extends Component {
  constructor(element) {
    super({
      store,
      element,
    })

    this.element = element

    const {
      actionUrl,
      type,
      messageNoCookies,
      messageNoApikey,
      googleApiUrl,
      locations,
      lat,
      lng,
      hasGoogleApi,
    } = element.dataset || {}

    delete element.dataset.locations
    delete element.dataset.actionUrl

    this.firstOpen = true
    this.actionUrl = actionUrl
    this.type = type ? type.toLowerCase() : null
    this.noCookiesMessage = messageNoCookies
    this.noApiKeyMessage = messageNoApikey
    this.googleApiUrl = googleApiUrl || false
    this.apiLoaded = false
    this.locations = locations
    this.location = { lat, lng }
    this.hasGoogleApi = hasGoogleApi

    this.ui = {
      map: element.querySelector(JS_HOOK_MAP) || false,
    }

    // this.invalidCookie = !Cookies.cookieIsValid(Cookies.cookieName.advertising)

    // // Cookie Check
    // if (this.invalidCookie) return this.cookieCheck()

    // Init
    this.start()
  }

  cookieCheck() {
    console.info('Cookies have not been accepted.')
    StoreLocator.showMessage(this.noCookiesMessage)
    Events.$on('cookies::changed', () => {
      if (Cookies.cookieIsValid(Cookies.cookieName.advertising)) StoreLocator.cookiesAccepted()
    })
  }

  static cookiesAccepted() {
    removeAlertMessage(JS_HOOK_ALERT)
    window.location.reload()
  }

  start() {
    // Init
    GoogleMaps.initApi(this.googleApiUrl)
    this.setInitialState()
    this.init()
    this.checkApiReady()

    // Events
    this.bindEvents()
  }

  setInitialState() {
    const initialState = {
      stores: parseJSON(this.locations, []),
      mapsApiReady: false,
      location: { lat: this.location.lat || 0, lng: this.location.lng || 0 },
    }

    const { stores, mapsApiReady, location } = initialState
    store.dispatch('setApi', { mapsApiReady })
    store.dispatch('setStores', { stores })
    store.dispatch('setLocation', { location })
  }

  static showMessage(message) {
    addAlertMessage({
      message,
      hook: JS_HOOK_ALERT,
      type: 'warning',
    })
  }

  init() {
    // If google api is set, we can continue with get all stores
    if (this.ui.map && this.hasGoogleApi !== 'true') {
      StoreLocator.showMessage(this.noApiKeyMessage)
    }
  }

  checkApiReady() {
    if (window.google && !this.apiLoaded) {
      this.apiLoaded = true
      store.dispatch('setApi', { mapsApiReady: true })
    }
  }

  static getData(data) {
    return {
      stores: data.stores || [],
    }
  }

  stateChanged() {
    const { state } = store

    const action =
      state.location.lat && state.location.lng && state.searchParam !== '' ? 'add' : 'remove'
    this.element.classList[action](HAS_SEARCHED_CLASS)
  }

  bindEvents() {
    Events.$on('google-maps-api::loaded', () => this.checkApiReady())
  }
}

export default StoreLocator
